(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-rp23"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = () => document.querySelectorAll('[data-rp23]').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  root.querySelectorAll('[data-gallery]').forEach(b=>b.addEventListener('click',()=>{
   const image=root.querySelector('.rp23-gallery-main');image.src=b.dataset.gallery;image.alt=b.dataset.galleryAlt||b.getAttribute('aria-label');
   root.querySelectorAll('[data-gallery-zoom]').forEach(link=>link.href=b.dataset.galleryFull||b.dataset.gallery);
   root.querySelectorAll('[data-gallery]').forEach(el=>el.setAttribute('aria-pressed',String(el===b)));
  }));
  root.querySelectorAll('[data-play]').forEach(b=>b.addEventListener('click',()=>{
   const frame=b.closest('[data-motion]');const playing=frame.classList.toggle('rp23-playing');b.setAttribute('aria-pressed',String(playing));
  }));
  root.querySelectorAll('[data-mode-control]').forEach(control=>{
   const modes=[...control.querySelectorAll('[data-control-mode]')];let index=0;
   const next=()=>{index=(index+1)%modes.length;modes.forEach((m,i)=>m.classList.toggle('is-selected',i===index));};
   control.querySelector('[data-mode-next]').addEventListener('click',next);
  });
  if('IntersectionObserver' in window){
   const proofObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting){entry.target.classList.add('is-visible');proofObserver.unobserve(entry.target);}
   }),{threshold:.25});
   root.querySelectorAll('[data-proof-moment]').forEach(panel=>proofObserver.observe(panel));
  }
  const stories=[...root.querySelectorAll('[data-story]')];
  const charge=root.querySelector('[data-charge]');
  const campaign=root.querySelector('[data-campaign]');
  const motionPreference=matchMedia('(prefers-reduced-motion: reduce)');
  const motionFrames=[...root.querySelectorAll('[data-motion]')];
  const animateFrame=(frame,active)=>{
   const playing=active && !motionPreference.matches && frame.dataset.paused!=='true';
   frame.classList.toggle('rp23-playing',playing);
   frame.querySelector('[data-play]').setAttribute('aria-pressed',String(playing));
  };
  motionFrames.forEach(frame=>frame.querySelector('[data-play]').addEventListener('click',()=>{
   frame.dataset.paused=String(!frame.classList.contains('rp23-playing'));
  }));
  if('IntersectionObserver' in window){
   const motionObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
    const frame=entry.target;
    frame.dataset.visible=String(entry.isIntersecting);
    const storyFrame=frame.closest('[data-story-frame]');
    animateFrame(frame,entry.isIntersecting && (!storyFrame || storyFrame.classList.contains('is-current')));
   }),{threshold:.15});
   motionFrames.forEach(frame=>motionObserver.observe(frame));
  }
  const demoVideos=[...root.querySelectorAll('[data-demo-video]')];
  const prepareVideo=video=>{
   if(video.dataset.loaded)return;
   video.dataset.loaded='true';video.preload='auto';video.load();
  };
  demoVideos.forEach(video=>{
   const button=video.parentElement.querySelector('[data-video-toggle]');
   video.controls=motionPreference.matches || !!navigator.connection?.saveData;button.hidden=false;
   const label=()=>{button.textContent=video.paused?button.dataset.playLabel:button.dataset.pauseLabel;};
   video.addEventListener('play',label);video.addEventListener('pause',label);label();
   button.addEventListener('click',()=>{
    if(video.paused){video.dataset.userPaused='false';prepareVideo(video);video.play().catch(()=>{video.controls=true;});}
    else{video.dataset.userPaused='true';video.pause();}
   });
  });
  const updateDemo=video=>{
   const frame=video.closest('[data-story-frame]');
   const active=video.dataset.visible==='true' && (!frame || frame.classList.contains('is-current')) && !motionPreference.matches && !navigator.connection?.saveData && video.dataset.userPaused!=='true' && !document.hidden;
   if(video.dataset.active===String(active))return;
   video.dataset.active=String(active);
   if(active){prepareVideo(video);video.muted=true;video.play().catch(()=>{video.controls=true;});}else video.pause();
  };
  if('IntersectionObserver' in window){
   const demoObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
    const video=entry.target;
    video.dataset.visible=String(entry.isIntersecting);
    updateDemo(video);
   }),{threshold:.35});
   demoVideos.forEach(video=>demoObserver.observe(video));
   const warmup=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting && !navigator.connection?.saveData && !motionPreference.matches){
     const video=entry.target.querySelector('[data-demo-video]');if(video)prepareVideo(video);
     warmup.unobserve(entry.target);
    }
   }),{rootMargin:'600px 0px'});
   demoVideos.forEach(video=>warmup.observe(video.closest('[data-story]')));
   document.addEventListener('visibilitychange',()=>demoVideos.forEach(updateDemo));
  }
  let motionPending=false;
  const updateStories=()=>{
   motionPending=false;
   if(motionPreference.matches)return;
   if(campaign){const rect=campaign.getBoundingClientRect();campaign.style.setProperty('--campaign-progress',Math.max(0,Math.min(1,-rect.top/rect.height)));}
   const anchor=innerHeight*(innerWidth<=700?.72:.53);
   stories.forEach(story=>{
    story.classList.add('is-story');
    const steps=[...story.querySelectorAll('[data-story-step]')];
    const rects=steps.map(step=>step.getBoundingClientRect());
    let index=0;
    rects.forEach((rect,i)=>{if(rect.top<anchor)index=i;});
    const progress=Math.max(0,Math.min(1,(anchor-rects[0].top)/(rects[rects.length-1].top-rects[0].top)));
    story.style.setProperty('--story-progress',progress);
    story.querySelectorAll('[data-story-frame]').forEach((frame,i)=>{
     frame.classList.toggle('is-current',i===index);
     frame.inert=i!==index;
     frame.setAttribute('aria-hidden',String(i!==index));
     const demoVideo=frame.querySelector('[data-demo-video]');
     if(demoVideo)updateDemo(demoVideo);
     const diagram=frame.querySelector('[data-motion]');
     if(diagram)animateFrame(diagram,i===index && rects[rects.length-1].bottom>0 && rects[0].top<innerHeight);
    });
   });
   if(charge){
    const rect=charge.getBoundingClientRect();
    const progress=Math.max(0,Math.min(1,(innerHeight*.88-rect.top)/Math.min(350,innerHeight*.48)));
    const count=Math.max(1,Math.round(progress*15));
    charge.querySelector('[data-charge-count]').textContent=count;
    charge.querySelectorAll('[data-session]').forEach((tick,i)=>{tick.style.opacity=i<count?'1':'.14';});
   }
  };
  const scheduleStories=()=>{if(!motionPending){motionPending=true;requestAnimationFrame(updateStories);}};
  window.addEventListener('scroll',scheduleStories,{passive:true});
  window.addEventListener('resize',scheduleStories,{passive:true});
  motionPreference.addEventListener('change',()=>{
   if(motionPreference.matches){
    stories.forEach(story=>{story.classList.remove('is-story');story.querySelectorAll('[data-story-frame]').forEach(f=>{f.removeAttribute('aria-hidden');f.inert=false;});});
    motionFrames.forEach(frame=>animateFrame(frame,false));
    demoVideos.forEach(video=>updateDemo(video));
    if(charge){charge.querySelector('[data-charge-count]').textContent='15';charge.querySelectorAll('[data-session]').forEach(t=>t.style.opacity='1');}
   }else scheduleStories();
  });
  scheduleStories();

  const film=root.querySelector('[data-scroll-film]');
  const video=film.querySelector('video');
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const saveData=!!navigator.connection?.saveData;
  const button=film.querySelector('[data-film-play]');
  const playLabel=button.textContent;
  const pauseLabel=root.querySelector('[data-video-toggle]')?.dataset.pauseLabel || 'Pause';
  let visible=false,userPaused=false;
  video.muted=true;video.loop=true;
  const label=()=>{button.textContent=video.paused?playLabel:pauseLabel;};
  const sync=()=>{
   video.autoplay=!reduced.matches&&!saveData;
   if(visible&&!document.hidden&&!userPaused&&!reduced.matches&&!saveData){
    prepareVideo(video);
    video.play().catch(()=>{video.controls=true;});
   }else video.pause();
  };
  video.addEventListener('play',label);video.addEventListener('pause',label);
  button.hidden=false;label();
  button.addEventListener('click',()=>{
   userPaused=!video.paused;
   if(userPaused)video.pause();
   else{prepareVideo(video);video.play().catch(()=>{video.controls=true;});}
  });
  if('IntersectionObserver' in window){
   video.controls=reduced.matches||saveData;
   new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.25}).observe(video);
  }else{visible=true;video.controls=true;}
  document.addEventListener('visibilitychange',sync);
  reduced.addEventListener('change',()=>{video.controls=reduced.matches||saveData;sync();});
  sync();
 });
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellogic-header"]) return;
  try {
    
  const closeNavigation = (disclosure, restoreFocus = false) => {
    disclosure.open = false;
    disclosure.querySelector('summary').setAttribute('aria-expanded', 'false');
    disclosure.querySelectorAll('[data-wl-nav-disclosure][open]').forEach(child => closeNavigation(child));
    if (restoreFocus) disclosure.querySelector('summary').focus();
  };

  const initializeNavigation = () => {
    document.querySelectorAll('[data-wl-nav-disclosure]').forEach(disclosure => {
      if (disclosure.dataset.wlNavReady) return;
      disclosure.dataset.wlNavReady = 'true';
      const trigger = disclosure.querySelector('summary');
      trigger.setAttribute('aria-expanded', String(disclosure.open));
      disclosure.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(disclosure.open));
        if (!disclosure.open) disclosure.querySelectorAll('[data-wl-nav-disclosure][open]').forEach(child => closeNavigation(child));
      });
    });
  };

  document.addEventListener('click', event => {
    document.querySelectorAll('[data-wl-nav-disclosure][open]').forEach(disclosure => {
      if (!disclosure.contains(event.target) || event.target.closest('a[href]')) closeNavigation(disclosure);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const focused = event.target.closest('[data-wl-nav-disclosure][open]');
    const disclosure = focused || document.querySelector('[data-wl-nav-disclosure][open]');
    if (disclosure) {
      event.preventDefault();
      closeNavigation(disclosure, true);
    }
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('[data-wl-nav-disclosure][open]').forEach(disclosure => {
      if (!disclosure.contains(event.target)) closeNavigation(disclosure);
    });
  });
  window.matchMedia('(max-width: 1100px)').addEventListener('change', () => {
    document.querySelectorAll('[data-wl-nav-disclosure][open]').forEach(disclosure => closeNavigation(disclosure));
  });
  document.addEventListener('shopify:section:load', initializeNavigation);
  initializeNavigation();

  } catch(e) { console.error(e); }
})();
})();
